<template>
  <UploadImage
    type="logo"
  />
</template>
<script>
import UploadImage from './components/UploadImage.vue'

export default {
  name: 'UploadLogo',
  components: {
    UploadImage,
  },
}
</script>
